<script>
    export default {
        name: "DialogRemote",
        props:['isOpen'],
        computed: {
            isDialogOpen: {
                get() {
                    return this.isOpen;
                },
                set(value) {
                    if(!value) {
                        this.$emit('close')
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
